import React, { useEffect, useState } from 'react';
import useRouter from 'src/shared/hooks/useRouter';

import GaService from 'src/services/GaService';
import MetaData from 'src/config/MetaData';
import RoutePaths from 'src/config/RoutePaths';
import MediaCategory from 'src/config/MediaCategory';
import { fireGA } from 'src/utils/gaUtils';
import LayoutWrapper from 'src/shared/components/LayoutWrapper';
import Section from 'src/shared/components/Section';

import useTabs from './hooks/useTabs';
import useMode from 'src/hooks/useMode';
import useFetchBasicListItems from './hooks/useFetchBasicListItems';
import TabBar from './components/TabBar';
import ListContent from './components/ListContent';
import styles from './styles.module.scss';
import ArticleCategoryModel from 'src/types/article/ArticleCategoryModel';

export const RECORDS_PER_SET = 10;
export const CATEGORIES = Object.values(MediaCategory);

interface Props {
    category: string;
}

const newsPageInfo = {
    [MediaCategory.INSIGHTS]: MetaData[RoutePaths.INSIGHTS],
    [MediaCategory.NEWS]: MetaData[RoutePaths.NEWS],
    [MediaCategory.EVENTS]: MetaData[RoutePaths.EVENTS],
};

const NewList = (props: Props) => {
    const { category } = props;
    const { route } = useRouter();
    const [page, setPage] = useState(1);
    const tabs = useTabs();
    const [header, setHeader] = useState('');
    const { isFetchingBasic, isFetchingAdditional, basicArticles, additionalArticles, featuredFromOthers, total } = useFetchBasicListItems(
        category,
        page
    );
    const { isMobile } = useMode();

    const pageInfo = newsPageInfo[category];
    const hasMorePages = total > page * RECORDS_PER_SET;

    const loadMore = async () => {
        // FIXME find a way to make it general
        let action: 'clickInsightsShowMore' | 'clickNewsShowMore' | 'clickEventsShowMore';
        switch (category) {
            case MediaCategory.INSIGHTS:
                action = 'clickInsightsShowMore';
                break;
            case MediaCategory.NEWS:
                action = 'clickNewsShowMore';
                break;
            case MediaCategory.EVENTS:
                action = 'clickEventsShowMore';
                break;
            default:
        }
        fireGA('marketingQ421', action);
        setPage(page + 1);
    };

    useEffect(() => {
        GaService.pageView(route);
        setHeader(tabs.find((tab) => tab.id === category).name);
        setPage(1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [category]);

    return (
        <LayoutWrapper
            className={styles.container}
            headerProps={{ type: 'black', fixed: true }}
            metaProps={{ title: pageInfo.title, description: pageInfo.description, keywords: pageInfo.keywords }}
        >
            <div className={styles.page}>
                <Section className={styles.section}>
                    {isMobile ? <TabBar tabs={tabs} focusedTab={category} /> : <h1 className={styles.title}>{header}</h1>}
                    <ListContent
                        isFetchingBasic={isFetchingBasic}
                        isFetchingAdditional={isFetchingAdditional}
                        hasMorePages={hasMorePages}
                        category={category}
                        basicArticles={basicArticles}
                        additionalArticles={additionalArticles}
                        featuredFromOthers={featuredFromOthers}
                        loadMore={loadMore}
                    />
                </Section>
            </div>
        </LayoutWrapper>
    );
};

export default NewList;
